import { FaKitchenSet as KITCHEN } from '@mirai/icons/build/fa6/FaKitchenSet';
import { GiForkKnifeSpoon as CUTLERY } from '@mirai/icons/build/gi/GiForkKnifeSpoon';
import { GiSlippers as SLIPPERS } from '@mirai/icons/build/gi/GiSlippers';
import { IoMdBicycle as BICYCLE } from '@mirai/icons/build/io/IoMdBicycle';
import { MdAir as AIR } from '@mirai/icons/build/md/MdAir';
import { MdAlarm as ALARM } from '@mirai/icons/build/md/MdAlarm';
import { MdBalcony as BALCONY } from '@mirai/icons/build/md/MdBalcony';
import { MdCable as CABLE } from '@mirai/icons/build/md/MdCable';
import { MdCheckCircleOutline as AMENITY } from '@mirai/icons/build/md/MdCheckCircleOutline';
import { MdFreeCancellation as FREE_CANCELLATION } from '@mirai/icons/build/md/MdFreeCancellation';
import { MdKeyboardDoubleArrowUp as KEYBOARD_UP } from '@mirai/icons/build/md/MdKeyboardDoubleArrowUp';
import { MdLockOutline as LOCK } from '@mirai/icons/build/md/MdLockOutline';
import { MdMoreTime as MORE_TIME } from '@mirai/icons/build/md/MdMoreTime';
import { MdOutlineBathtub as BATH } from '@mirai/icons/build/md/MdOutlineBathtub';
import { MdOutlineBeachAccess as BEACH } from '@mirai/icons/build/md/MdOutlineBeachAccess';
import { MdOutlineBedroomBaby as BEDROOM_BABY } from '@mirai/icons/build/md/MdOutlineBedroomBaby';
import { MdOutlineCardGiftcard as CARD_GIFT } from '@mirai/icons/build/md/MdOutlineCardGiftcard';
import { MdOutlineChildFriendly as CHILD } from '@mirai/icons/build/md/MdOutlineChildFriendly';
import { MdOutlineCoffeeMaker as COFFEE_MAKER } from '@mirai/icons/build/md/MdOutlineCoffeeMaker';
import { MdOutlineDesk as DESK } from '@mirai/icons/build/md/MdOutlineDesk';
import { MdOutlineDiscount as DISCOUNT } from '@mirai/icons/build/md/MdOutlineDiscount';
import { MdOutlineDryCleaning as DRY_CLEANING } from '@mirai/icons/build/md/MdOutlineDryCleaning';
import { MdOutlineFitnessCenter as FITNESS } from '@mirai/icons/build/md/MdOutlineFitnessCenter';
import { MdOutlineFreeBreakfast as BREAKFAST } from '@mirai/icons/build/md/MdOutlineFreeBreakfast';
import { MdOutlineGolfCourse as GOLF } from '@mirai/icons/build/md/MdOutlineGolfCourse';
import { MdOutlineIron as IRON } from '@mirai/icons/build/md/MdOutlineIron';
import { MdOutlineLiving as LIVING_ROOM } from '@mirai/icons/build/md/MdOutlineLiving';
import { MdOutlineLocalBar as BAR } from '@mirai/icons/build/md/MdOutlineLocalBar';
import { MdOutlineLocalLaundryService as WASHER } from '@mirai/icons/build/md/MdOutlineLocalLaundryService';
import { MdOutlineLocalParking as PARKING } from '@mirai/icons/build/md/MdOutlineLocalParking';
import { MdOutlineLocalTaxi as TAXI } from '@mirai/icons/build/md/MdOutlineLocalTaxi';
import { MdOutlineMenuBook as MENU } from '@mirai/icons/build/md/MdOutlineMenuBook';
import { MdOutlineMicrowave as MICROWAVE } from '@mirai/icons/build/md/MdOutlineMicrowave';
import { MdOutlineMuseum as MUSEUM } from '@mirai/icons/build/md/MdOutlineMuseum';
import { MdOutlineNewspaper as NEWSPAPER } from '@mirai/icons/build/md/MdOutlineNewspaper';
import { MdOutlineOutdoorGrill as BARBECUE } from '@mirai/icons/build/md/MdOutlineOutdoorGrill';
import { MdOutlinePercent as PERCENT } from '@mirai/icons/build/md/MdOutlinePercent';
import { MdOutlinePool as POOL } from '@mirai/icons/build/md/MdOutlinePool';
import { MdOutlineQuestionAnswer as ANSWER } from '@mirai/icons/build/md/MdOutlineQuestionAnswer';
import { MdOutlineRadio as RADIO } from '@mirai/icons/build/md/MdOutlineRadio';
import { MdOutlineRateReview as RATE_REVIEW } from '@mirai/icons/build/md/MdOutlineRateReview';
import { MdOutlineRoomPreferences as ROOM_PREFERENCES } from '@mirai/icons/build/md/MdOutlineRoomPreferences';
import { MdOutlineShower as SHOWER } from '@mirai/icons/build/md/MdOutlineShower';
import { MdOutlineSpa as SPA } from '@mirai/icons/build/md/MdOutlineSpa';
import { MdOutlineSpeaker as SPEAKER } from '@mirai/icons/build/md/MdOutlineSpeaker';
import { MdOutlineStarBorder as STAR } from '@mirai/icons/build/md/MdOutlineStarBorder';
import { MdOutlineSurroundSound as SURROUND } from '@mirai/icons/build/md/MdOutlineSurroundSound';
import { MdOutlineTablet as TABLET } from '@mirai/icons/build/md/MdOutlineTablet';
import { MdOutlineWash as WASH_BASIN } from '@mirai/icons/build/md/MdOutlineWash';
import { MdOutlineWaterDrop as WATER } from '@mirai/icons/build/md/MdOutlineWaterDrop';
import { MdOutlineWbSunny as SUN } from '@mirai/icons/build/md/MdOutlineWbSunny';
import { PiFan as FAN } from '@mirai/icons/build/pi/PiFan';
import { PiFlowerTulip as FLOWER } from '@mirai/icons/build/pi/PiFlowerTulip';
import { PiToilet as TOILET } from '@mirai/icons/build/pi/PiToilet';
import { Ri24HoursLine as TWENTY_FOUR_HOURS } from '@mirai/icons/build/ri/Ri24HoursLine';
import { RiFridgeLine as FRIDGE } from '@mirai/icons/build/ri/RiFridgeLine';
import { RiPhoneLine as PHONE } from '@mirai/icons/build/ri/RiPhoneLine';
import { RiSafe2Line as SAFE } from '@mirai/icons/build/ri/RiSafe2Line';
import { RiShirtLine as CLOTHES } from '@mirai/icons/build/ri/RiShirtLine';
import { RiTempHotLine as HEATING } from '@mirai/icons/build/ri/RiTempHotLine';
import { RiTvLine as TV } from '@mirai/icons/build/ri/RiTvLine';
import { RiWifiLine as WIFI } from '@mirai/icons/build/ri/RiWifiLine';
import { TbAirConditioning as AIR_CONDITIONING } from '@mirai/icons/build/tb/TbAirConditioning';
import { TbScaleOutline as SCALE } from '@mirai/icons/build/tb/TbScaleOutline';
import { TbSofa as SOFA } from '@mirai/icons/build/tb/TbSofa';
import { ICON } from '@mirai/ui';

export const ICON_AMENITIES = {
  AMENITY,
  1: KITCHEN,
  2: FRIDGE,
  3: WASHER,
  4: MICROWAVE,
  5: IRON,
  6: COFFEE_MAKER,
  7: WASH_BASIN,
  8: LIVING_ROOM,
  9: BALCONY,
  10: BALCONY,
  11: RADIO,
  13: TV,
  14: PHONE,
  15: AIR_CONDITIONING,
  16: BAR,
  17: BAR,
  18: SAFE,
  19: SAFE,
  20: CABLE,
  21: CABLE,
  22: WIFI,
  23: WIFI,
  // 24: 'suelo_moqueta',
  // 25: 'suelo_parquet',
  // 26: 'suelo_madera',
  // 27: 'suelo_marmol',
  // 28: 'suelo_baldosas',
  51: SHOWER,
  52: BATH,
  53: BATH,
  54: BATH,
  55: WATER,
  // 56: 'bidet',
  57: AIR,
  // 58: 'espejo_maquillaje',
  // 59: 'albornoz',
  60: SLIPPERS,
  61: TABLET,
  62: TABLET,
  63: BATH,
  64: BARBECUE,
  65: HEATING,
  67: KITCHEN,
  68: KITCHEN,
  69: DESK,
  // 70: 'horno',
  71: WATER,
  // 72: 'jaima',
  73: FLOWER,
  74: WASHER,
  75: CUTLERY,
  76: POOL,
  77: POOL,
  79: LIVING_ROOM,
  80: SUN,
  // 81: 'tocador',
  82: FAN,
  83: CLOTHES,
  84: BEACH,
  85: BEACH,
  // 86: 'vitroceramica',
  87: BATH,
  90: SOFA,
  91: SOFA,
  92: TOILET,
  93: ALARM,
  // 94: 'camas_balinesas',
  // 95: 'hamacas',
  96: HEATING,
  97: BEACH,
  98: WATER,
  99: BATH,
  100: TWENTY_FOUR_HOURS,
  101: COFFEE_MAKER,
  102: TV,
  103: TAXI,
  // 104: 'docking_station',
  // 105: 'amenities_bulgari',
  106: WASHER,
  // 107: 'hamacas_sumergidas',
  108: SHOWER,
  109: NEWSPAPER,
  111: TV,
  112: SCALE,
  113: TAXI,
  114: PHONE,
  115: BREAKFAST,
  116: GOLF,
  117: SURROUND,
  118: SPEAKER,
  // 119: 'amenities_bano',
  120: TWENTY_FOUR_HOURS,
  121: MENU,

  200: ICON.CHECK,
  201: CHILD,
  202: DRY_CLEANING,
  203: BICYCLE,
  204: RATE_REVIEW,
  205: BEDROOM_BABY,
  206: CARD_GIFT,
  207: STAR,
  208: FREE_CANCELLATION,
  209: FITNESS,
  210: PARKING,
  211: LOCK,
  212: PERCENT,
  213: SPA,
  214: KEYBOARD_UP,
  215: ANSWER,
  216: DISCOUNT,
  217: ROOM_PREFERENCES,
  218: MORE_TIME,
  219: MUSEUM,
};
